"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./ModalVideoLauncherCard.css");

var _react = _interopRequireDefault(require("react"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarketingVideo = _interopRequireDefault(require("../../shared/components/video/MarketingVideo"));

var _constants = require("../../util/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalVideoLauncherCard = function ModalVideoLauncherCard(_ref) {
  var videoModal = _ref.videoModal,
      videoSource = _ref.videoSource,
      videoPreviewImageSource = _ref.videoPreviewImageSource,
      videoGoogleAnalyticsName = _ref.videoGoogleAnalyticsName,
      logoProps = _ref.logoProps,
      textBodyProps = _ref.textBodyProps,
      dispatcher = _ref.dispatcher;

  var handleVideoClick = function handleVideoClick(e) {
    dispatcher.emit("OPEN_MODAL", {
      modalKey: videoModal.modalKey
    });
  };

  var handleOnKeyUp = function handleOnKeyUp(e) {
    if (e.which === _constants.KEYCODES.ENTER) {
      handleVideoClick();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-video-launcher-card"
  }, /*#__PURE__*/_react.default.createElement(_MarketingVideo.default, {
    videoModal: videoModal,
    src: videoSource,
    gaName: videoGoogleAnalyticsName,
    renderButton: function renderButton() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "preview-image-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "preview-image",
        alt: "video-preview",
        src: videoPreviewImageSource,
        role: "presentation",
        onClick: handleVideoClick,
        onKeyUp: handleOnKeyUp
      }));
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-wrapper"
  }, logoProps && /*#__PURE__*/_react.default.createElement("img", {
    alt: logoProps.altText,
    className: "logo",
    src: logoProps.source
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marketing-video-body"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "marketing-video-header"
  }, textBodyProps.textBodyHeader), /*#__PURE__*/_react.default.createElement("p", {
    className: "marketing-video-bodytext"
  }, textBodyProps.textBodyContent), /*#__PURE__*/_react.default.createElement("button", {
    className: "button",
    onClick: handleVideoClick,
    onKeyUp: handleOnKeyUp
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "play-button",
    src: require("../assets/redesign2020/marketing-video-testimonial/play-button.png"),
    alt: "Play Video"
  }), /*#__PURE__*/_react.default.createElement("span", null, "Watch Video"))));
};

ModalVideoLauncherCard.propTypes = {
  videoModal: _propTypes.default.object.isRequired
};

var _default = (0, _Propulator.default)(ModalVideoLauncherCard, {});

exports.default = _default;